import {useProductReview} from '../../../context/ProductReviewContext'
import {ProductReviewData} from '../../ui/ProductReviewData'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {getDisplaySizeIdError} from '../../utils/productReviewValidation'
import {PRODUCT_REVIEW_DISPLAY_SIZE_SECTION} from '../productReviewDataMap'

export const DisplaySizeSection = () => {
  const {productData} = useProductReview()
  const displaySizeIdError = getDisplaySizeIdError(productData?.display?.displaySizeId)

  return (
    <ProductReviewSection title="Display Size">
      <ProductReviewData
        sections={[PRODUCT_REVIEW_DISPLAY_SIZE_SECTION]}
        fieldErrors={displaySizeIdError ? {'display.displaySizeId': displaySizeIdError} : {}}
      />
    </ProductReviewSection>
  )
}
